// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-complete {
  --invite-primary: #133f7a;
  --invite-accent: #f16622;
  --invite-text: #1f2937;
  --invite-muted: #4b5563;
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  min-height: 100vh;
  position: relative;
  font-family: Arial, Helvetica, sans-serif;
  color: var(--invite-text);
}

.invite-complete::before {
  content: "";
  position: fixed;
  inset: 0;
  background: url("https://birddata.blob.core.windows.net/b2clogin/cust-app/images/background.png") center/cover no-repeat fixed;
  filter: grayscale(100%);
  z-index: -2;
}

.invite-complete::after {
  content: "";
  position: fixed;
  inset: 0;
  background: linear-gradient(rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.88));
  z-index: -1;
}

.invite-complete__page {
  min-height: 100dvh;
  display: grid;
  grid-template-rows: auto 1fr auto;
}

.invite-complete__topbar {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffffcc;
  backdrop-filter: saturate(120%) blur(2px);
  border-bottom: 1px solid #e5e7eb;
  padding: 8px 12px;
  gap: 8px;
}

.invite-complete__topbar img.invite-complete__brand {
  height: 36px;
  object-fit: contain;
}

.invite-complete__topbar img.invite-complete__logo-small {
  height: 36px;
  width: auto;
  object-fit: contain;
}

.invite-complete__content {
  display: grid;
  grid-template-columns: minmax(320px, 1.1fr) minmax(340px, 1fr);
  gap: clamp(16px, 2.5vw, 28px);
  align-items: center;
  padding: clamp(12px, 2.5vw, 24px) clamp(16px, 3.2vw, 40px);
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
}

.invite-complete__leftmark {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  opacity: 0.92;
  text-align: center;
}

.invite-complete__from {
  color: #9ca3af;
  font-size: 14px;
  margin: 6px 0 4px;
}

.invite-complete__brandline {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.invite-complete__brandline img.invite-complete__logo-small {
  height: clamp(28px, 3.3vw, 44px);
}

.invite-complete__brandline img.invite-complete__logo-text {
  height: clamp(26px, 3vw, 40px);
}

.invite-complete__panel {
  justify-self: center;
  background: rgba(243, 244, 246, 0.45);
  border: 1px solid rgba(15, 23, 42, 0.04);
  border-radius: 12px;
  padding: clamp(16px, 2vw, 24px);
  width: min(92vw, 520px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(2.5px) saturate(108%);
}

.invite-complete__panel .ant-result {
  padding: 0;
}

.invite-complete__footer {
  text-align: center;
  color: #94a3b8;
  font-size: 12px;
  padding-bottom: 8px;
}

@media (max-width: 1280px) {
  .invite-complete__content {
    max-width: 1140px;
  }
}

@media (max-width: 1024px) {
  .invite-complete__content {
    grid-template-columns: 1fr;
    max-width: 920px;
  }

  .invite-complete__panel {
    justify-self: center;
  }

  .invite-complete__leftmark {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .invite-complete__topbar img.invite-complete__brand {
    height: 30px;
  }

  .invite-complete__content {
    padding: 16px;
    gap: 18px;
  }
}

@media (max-width: 480px) {
  .invite-complete__brandline img.invite-complete__logo-small {
    height: 28px;
  }

  .invite-complete__brandline img.invite-complete__logo-text {
    height: 26px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/InviteComplete/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,8HAA8H;EAC9H,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,iFAAiF;EACjF,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yCAAyC;EACzC,gCAAgC;EAChC,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,6BAA6B;EAC7B,mBAAmB;EACnB,0DAA0D;EAC1D,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".invite-complete {\n  --invite-primary: #133f7a;\n  --invite-accent: #f16622;\n  --invite-text: #1f2937;\n  --invite-muted: #4b5563;\n  width: 100vw;\n  margin-left: calc(50% - 50vw);\n  margin-right: calc(50% - 50vw);\n  min-height: 100vh;\n  position: relative;\n  font-family: Arial, Helvetica, sans-serif;\n  color: var(--invite-text);\n}\n\n.invite-complete::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background: url(\"https://birddata.blob.core.windows.net/b2clogin/cust-app/images/background.png\") center/cover no-repeat fixed;\n  filter: grayscale(100%);\n  z-index: -2;\n}\n\n.invite-complete::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background: linear-gradient(rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.88));\n  z-index: -1;\n}\n\n.invite-complete__page {\n  min-height: 100dvh;\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n}\n\n.invite-complete__topbar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffffcc;\n  backdrop-filter: saturate(120%) blur(2px);\n  border-bottom: 1px solid #e5e7eb;\n  padding: 8px 12px;\n  gap: 8px;\n}\n\n.invite-complete__topbar img.invite-complete__brand {\n  height: 36px;\n  object-fit: contain;\n}\n\n.invite-complete__topbar img.invite-complete__logo-small {\n  height: 36px;\n  width: auto;\n  object-fit: contain;\n}\n\n.invite-complete__content {\n  display: grid;\n  grid-template-columns: minmax(320px, 1.1fr) minmax(340px, 1fr);\n  gap: clamp(16px, 2.5vw, 28px);\n  align-items: center;\n  padding: clamp(12px, 2.5vw, 24px) clamp(16px, 3.2vw, 40px);\n  max-width: 1280px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.invite-complete__leftmark {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  opacity: 0.92;\n  text-align: center;\n}\n\n.invite-complete__from {\n  color: #9ca3af;\n  font-size: 14px;\n  margin: 6px 0 4px;\n}\n\n.invite-complete__brandline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.invite-complete__brandline img.invite-complete__logo-small {\n  height: clamp(28px, 3.3vw, 44px);\n}\n\n.invite-complete__brandline img.invite-complete__logo-text {\n  height: clamp(26px, 3vw, 40px);\n}\n\n.invite-complete__panel {\n  justify-self: center;\n  background: rgba(243, 244, 246, 0.45);\n  border: 1px solid rgba(15, 23, 42, 0.04);\n  border-radius: 12px;\n  padding: clamp(16px, 2vw, 24px);\n  width: min(92vw, 520px);\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(2.5px) saturate(108%);\n}\n\n.invite-complete__panel .ant-result {\n  padding: 0;\n}\n\n.invite-complete__footer {\n  text-align: center;\n  color: #94a3b8;\n  font-size: 12px;\n  padding-bottom: 8px;\n}\n\n@media (max-width: 1280px) {\n  .invite-complete__content {\n    max-width: 1140px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .invite-complete__content {\n    grid-template-columns: 1fr;\n    max-width: 920px;\n  }\n\n  .invite-complete__panel {\n    justify-self: center;\n  }\n\n  .invite-complete__leftmark {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .invite-complete__topbar img.invite-complete__brand {\n    height: 30px;\n  }\n\n  .invite-complete__content {\n    padding: 16px;\n    gap: 18px;\n  }\n}\n\n@media (max-width: 480px) {\n  .invite-complete__brandline img.invite-complete__logo-small {\n    height: 28px;\n  }\n\n  .invite-complete__brandline img.invite-complete__logo-text {\n    height: 26px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
